__webpack_require__.p = "${VUE_APP_FRONTEND_CDN}/";